import { v2Api } from './v2Client';

// Replays : rediffusions YouTube des terrains découpées en matchs par le worker local (API /Replay/*, staff ;
// voir squash_manger_api_v2/docs/REPLAYS.md). Réponses en snake_case, erreurs { error, message }.

function normArr(data) {
  return Array.isArray(data) ? data : [];
}

async function post(path, payload) {
  const { data } = await v2Api.post(path, payload);
  return data;
}

export const REPLAY_STATUS_LABELS = {
  draft: 'Brouillon',
  queued: 'En file',
  processing: 'Analyse…',
  done: 'Terminé',
  failed: 'Échec',
};

export const replayService = {
  /** GET /Replay/list — vidéos du club (avec segments_total / segments_linked). */
  list: async () => {
    const { data } = await v2Api.get('/Replay/list');
    return normArr(data);
  },
  /** POST /Replay/get — { video, segments, candidates }. */
  get: (id) => post('/Replay/get', { id }),
  /** POST /Replay/upsert — { id?, video_date: 'YYYY-MM-DD', youtube_url, terrain_id } → vidéo. */
  upsert: (payload) => post('/Replay/upsert', payload),
  remove: (id) => post('/Replay/delete', { id }),
  /** POST /Replay/queue — « Fragmenter » (relance possible depuis done / failed). */
  queue: (id) => post('/Replay/queue', { id }),
  /** POST /Replay/stop — « Arrêter » : vidéo en file / en analyse → échec (relançable). */
  stop: (id) => post('/Replay/stop', { id }),
  /**
   * POST /Replay/link_segment — match_id → lien manuel ; match_id null + ignore false → délié ; ignore true → ignoré.
   * Renvoie le segment à jour.
   */
  linkSegment: (segmentId, { matchId = null, ignore = false } = {}) =>
    post('/Replay/link_segment', { segment_id: segmentId, match_id: matchId, ignore: Boolean(ignore) }),
};
